import { useState } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

// Botón "X" que borra una línea, con confirmación inline (popover, no window.confirm).
export const EliminarConConfirmacion = ({ mensaje, onConfirmar, testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" title="Eliminar" data-testid={testId}
          className="w-7 h-7 flex items-center justify-center rounded-full bg-pink-50 text-pink-600 hover:bg-pink-100">
          <X size={14} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 p-3" data-testid={`${testId}-popover`}>
        <p className="text-sm text-slate-700">{mensaje}</p>
        <div className="mt-3 flex justify-end gap-2">
          <Button type="button" variant="outline" size="sm" data-testid={`${testId}-cancelar`}
            onClick={() => setOpen(false)}>Cancelar</Button>
          <Button type="button" size="sm" data-testid={`${testId}-confirmar`}
            className="bg-pink-600 hover:bg-pink-700 text-white"
            onClick={() => { setOpen(false); onConfirmar(); }}>Eliminar</Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
